(function($){

	function initMasonry() {
		$('[data-masonry-grid]').isotope({
		 	itemSelector: '[data-masonry-entry]',
		  	masonry: {
			  columnWidth: '[data-masonry-entry]',
			}
		});
	}

	$(window).on('load resize', initMasonry);

	$('.select-li').on('click', function() {
		setTimeout(function() {
			initMasonry();
		}, 100);
	});

}(jQuery));